import React, { useState, useEffect } from "react";
import { sendmail } from "../api/api";
import ReCAPTCHA from "react-google-recaptcha";
import config from "../config/mail.json";
import ResponseDialog from "./dialog/ResponseDialog";

const Mailbox = () => {
    const [email, setEmail] = useState("");
    const [subject, setSubject] = useState("");
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [phone, setPhone] = useState("");
    const [message, setMessage] = useState("");
    const [recaptchaToken, setRecaptchaToken] = useState("");
    const [typemessage, setTypemessage] = useState("");
    const [resmessage, setResmessage] = useState("");

    const validateEmail = (email) => {
        return /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email);
    };

    const formData = {
        email,
        subject,
        firstname,
        lastname,
        phone,
        message,
        recaptchaToken
      };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setTypemessage("info");
        setResmessage("Sending...");

        if (!validateEmail(email)) {
            setResmessage("Please enter a valid email address.");
        return;
        }

        const response = await sendmail(formData);
        setTypemessage(response.type);
        if (response.type === "success") {
            setEmail("");
            setSubject("");
            setFirstname("");
            setLastname("");
            setPhone("");
            setMessage("");
            setRecaptchaToken("");
        }else{
            setRecaptchaToken("");
        }
        setResmessage(response.message);
    };

    return(
                <div className="card">
                    <div className="card-header">
                        <h5>Mailbox</h5>
                    </div>
                    <div className="card-body">
                    {typemessage && resmessage && <ResponseDialog type={typemessage} message={resmessage} onClose={() => setResmessage("")} />}

                        <form onSubmit={handleSubmit} method="post" className="php-email-form" data-aos="fade-up" data-aos-delay={200}>
                            <div className="row">
                                <div className="col-md-6">
                                    <label htmlFor="firstname-field">First Name</label>
                                    <input type="text" name="firstname" id="firstname-field" className="form-control" autoComplete="off" required 
                                        value={firstname}
                                        onChange={(e) => setFirstname(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="lastname-field">Last Name</label>
                                    <input type="text" name="lastname" id="lastname-field" className="form-control" autoComplete="off" required 
                                        value={lastname}
                                        onChange={(e) => setLastname(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="email-field">Business Email</label>
                                    <input type="email" className="form-control" name="email" id="email-field" autoComplete="off" required
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="phone-field">Phone Number</label>
                                    <input type="number" className="form-control" name="phone" id="phone-field" autoComplete="off" required 
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-12">
                                    <label htmlFor="subject-field">Subject</label>
                                    <input type="text" className="form-control" name="subject" id="subject-field" required 
                                        value={subject}
                                        onChange={(e) => setSubject(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-12">
                                    <label htmlFor="message-field">Message</label>
                                    <textarea className="form-control" name="message" rows={10} id="message-field" required defaultValue={""} 
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                    />
                                </div>
                                <div className="col-md-6 pt-3 align-self-end">
                                    <ReCAPTCHA
                                        sitekey={config.ReCAPTCHA}
                                        onChange={(token) => setRecaptchaToken(token)}
                                    />
                                </div>
                                <div className="col-md-6 text-right align-self-end">
                                    <button type="submit" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#successDialog">SEND</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
    )
}
export default Mailbox;